import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as styles from './customers-and-suppliers.scss';
import { TABLE_COLUMN } from '../../../../utils/table-filters/filter-table-types';

export const customersSuppliersColumns = [
  {
    display_name: <FormattedMessage id="predict.type_uc" defaultMessage="TYPE" />,
    name: TABLE_COLUMN.TYPE,
    classes: styles.flex1
  },
  {
    display_name: <FormattedMessage id="predict.contact_uc" defaultMessage="CONTACT" />,
    name: TABLE_COLUMN.CONTACT,
    classes: styles.flex2
  },
  {
    display_name: <FormattedMessage id="predict.total_due_uc" defaultMessage="TOTAL DUE" />,
    name: TABLE_COLUMN.TOTAL_DUE,
    classes: styles.flex1
  },
  {
    display_name: <FormattedMessage id="predict.total_overdue_uc" defaultMessage="TOTAL OVERDUE" />,
    name: TABLE_COLUMN.TOTAL_OVERDUE,
    classes: styles.flex1
  },
  {
    display_name: <FormattedMessage id="predict.total_invoiced_uc" defaultMessage="TOTAL INVOICED" />,
    name: TABLE_COLUMN.TOTAL_INVOICED,
    classes: styles.flex1
  },
  {
    display_name: <FormattedMessage id="predict.invoices_due_uc" defaultMessage="INVOICES DUE" />,
    name: TABLE_COLUMN.INVOICES_DUE,
    classes: styles.flex1
  },
  {
    display_name: <FormattedMessage id="predict.average_sale_uc" defaultMessage="AVERAGE SALE" />,
    name: TABLE_COLUMN.AVERAGE_SALE,
    classes: styles.flex1
  },
  {
    display_name: <FormattedMessage id="predict.days_to_pay_uc" defaultMessage="DAYS TO PAY" />,
    name: TABLE_COLUMN.DAYS_TO_PAY,
    classes: styles.flex1
  },
  {
    display_name: <FormattedMessage id="predict.dependence_uc" defaultMessage="DEPENDENCE" />,
    name: TABLE_COLUMN.DEPENDENCE,
    classes: styles.flex1
  },
  {
    display_name: <FormattedMessage id="predict.last_activity_uc" defaultMessage="LAST ACTIVITY" />,
    name: TABLE_COLUMN.LAST_ACTIVITY,
    classes: styles.flex1
  }
];
